import { Tag, Button } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

/**
 * createColumns
 * Complemento para mostrar las tablas tanto como en antd y modo responsive
 * @param {Function} showEditModal
 * @param {Function} showDeleteModal
 * @param {Number} page
 */
export function createColumns(page = 1, showEditModal = null, showDeleteModal = null) {
  return [
    {
      title: "N.º",
      key: "index",
      render: (value, item, index) => (page - 1) * 10 + index + 1
    },
    {
      title: "Usuario",
      dataIndex: "usuario",
      key: "usuario",
      sorter: (a, b) => a.usuario.localeCompare(b.usuario)
    },
    {
      title: "DNI",
      dataIndex: "nrodocumento",
      key: "nrodocumento",
      sorter: (a, b) => a.nrodocumento.localeCompare(b.nrodocumento)
    },
    {
      title: "Nombres",
      dataIndex: "nombre",
      key: "nombre",
      sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Apellidos",
      dataIndex: "apellido",
      key: "apellido",
      sorter: (a, b) => a.apellido.localeCompare(b.apellido),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Rol",
      dataIndex: "idrol",
      key: "idrol",
      render: (role) => {
        let color = "";
        let text = "";
        switch (role) {
          case 1:
            color = "green";
            text = "ADMINISTRADOR";
            break;
          case 3:
            color = "blue";
            text = "VISITANTE";
            break;
          default:
            break;
        }
        return (
          <Tag color={color} key={role}>
            {text}
          </Tag>
        );
      },

      filters: [
        {
          text: "ADMINISTRADOR",
          value: 1
        },
        {
          text: "VISITANTE",
          value: 3
        }
      ],
      filterMultiple: true,
      onFilter: (value, record) => record.role.indexOf(value) === 0,
      sorter: (a, b) => {
        return a.role.length - b.role.length;
      },
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Acciones",
      key: "action",
      render: (record) => (
        <span>
          <Button icon={<EditOutlined />} onClick={() => showEditModal(record)} />
          &nbsp;
          <Button icon={<DeleteOutlined />} onClick={() => showDeleteModal(record)} />
        </span>
      )
    }
  ];
}
